<div class="detail-sections mb-4 px-3">
    <div class="col-12">
        <div class="d-flex justify-content-between">
            <ng-content />
        </div>
    </div>
</div>
